/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { BRIDGE_ENTITY_NAME, ENTITY_NAMES } from '../constants/threadConstants';
import { BlendBridge } from 'blb-types/blendBridge';
import { convertToDateFormat, getDiffInUnits, getStartOfDateIsoString } from 'blb-utils/date';
import { MessageUser } from '../types';
import { DateTime } from 'luxon';
import { filter } from 'lodash';

export const threadHasANewMessage = (lastReplyByEntityType: BlendBridge.API.EntityType): boolean => {
  return lastReplyByEntityType !== BRIDGE_ENTITY_NAME;
};

export const getReplyDate = (createdAt: string) => {
  const startOfToday = getStartOfDateIsoString(DateTime.local().toISO(), 'day');
  const startOfDate = getStartOfDateIsoString(createdAt, 'day');
  const dateDiff = getDiffInUnits(startOfToday, startOfDate, 'day');
  if (dateDiff === 0) {
    return 'Today';
  } else if (dateDiff === 1) {
    return 'Yesterday';
  } else {
    return convertToDateFormat(createdAt, 'MMMM d');
  }
};

export const getReplyByNameAndTime = (lastRepliedBy: BlendBridge.API.LastReply): string => {
  const { entityUser, createdAt, entityType } = lastRepliedBy;

  const entityName = ENTITY_NAMES[entityType];
  const fullName = `${entityUser.firstName} ${entityUser.lastName.charAt(0)}`;
  const replyDate = getReplyDate(createdAt);
  const replyTime = convertToDateFormat(createdAt, 'h:mm a');

  return `(${entityName}) ${fullName} · Sent ${replyDate} ${replyTime}`;
};

export const formatUserForMessage = (user: MessageUser): BlendBridge.API.InboxUser => {
  return {
    entityType: 'BLEND_TITLE_AGENCY' as BlendBridge.API.EntityType,
    // note that BLEND_TITLE_AGENCY is a unique first name that gets overridden in the messenger service ("Blend Title Agency" | "Title365")
    firstName: user?.firstName || 'BLEND_TITLE_AGENCY',
    id: user.id!,
    lastName: user?.lastName || ' ',
  };
};

export const getFilteredThreads = (threads: BlendBridge.API.Thread[], topic?: BlendBridge.API.Topic) => {
  if (!topic) return threads;
  return filter(threads, thread => thread.topic === topic);
};
